var nurseslounge_profile = {
    profile:function($params){
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_myDashboard_followAndFriend.init($params);
        nurseslounge_profile.submenu($params, function(){
            $(".nav-underline a:eq(0)").click();
        });
    },
    profile_sub:function($params){
        nurseslounge_myDashboard_followAndFriend.init($params);
        nurseslounge_myDashboard_myProfile.init($params);
    },
    activity:function($params){
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_myDashboard_followAndFriend.init($params);
        nurseslounge_profile.submenu($params, function(){
            $(".nav-underline a:eq(1)").click();
        });
    },
    activity_sub:function($params){
        nurseslounge_myDashboard_activity.init($params);
    },
    colleagues:function($params){
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_myDashboard_followAndFriend.init($params);
        nurseslounge_profile.submenu($params, function(){
            $(".nav-underline a:eq(2)").click();
        });
    },
    colleagues_sub:function($params){
        nurseslounge_myDashboard_followAndFriend.init($params);
        nurseslounge_myDashboard_colleagues.init($params);
    },
    submenu:function($params, cback){
        $(".nav-underline a").unbind().click(function(){
            $(".nav-underline a").removeClass('active');
            var $url = $(this).data('url');
            var $previewProfile = libs.memoryGet('preview_profile');
            if(
                $params.guestId != libs.memoryGet('user_id') ||
                $previewProfile && $previewProfile == 1
            ){
                $url = $url.split('/');
                var $newUrl = [];
                $newUrl.push('profile');
                $newUrl.push($params.guestId);
                $newUrl.push($url[2]);
                $newUrl = $newUrl.join('/');
                $url = '/'+$newUrl;
                nurseslounge_profile.submenu_open(this, $url,  $(this).data('id')+'_sub', $params)
            }else{
                router.navigate($url);
            }
        });
        nurseslounge_profile.menu_selector();
        var $notification = nurseslounge_profile.notification_open($params, window.location.href.toString());
        if($notification.valid){
            var $open = '';
            switch($params.notification_type){
                case  'profile':{$open = 'activity';break;}
            }
            $(".nav-underline a").each(function(){
                var $that = $(this);
                if($that.data('id') == $open){
                    $that.addClass('active')
                }
            });
            $params = $.extend({}, $params, {user_id:libs.memoryGet('user_id')});
            libs.subrender($notification.url, 'nurseslounge_profile', $notification.module+'_sub', $params, 'POST');
        }else{
            cback();
        }
    },
    submenu_open:function($this, $url, $module, $params){
        $params = $.extend({}, $params, {
            user_id:libs.memoryGet('user_id'),
            notification_key:null,
            notification_type:null,
            notification_type_key:null,
        });
        $($this).addClass('active');
        router.pause();
        router.navigate($url);
        router.resume();
        libs.subrender($url, 'nurseslounge_profile', $module, $params, 'POST');
    },
    notification_open:function($params, $location){
        var $notification = {};
        var $notificationData = [];
        if($params.notification_key){$notificationData.push($params.notification_key);}
        if($params.notification_type){$notificationData.push($params.notification_type);}
        if($params.notification_type_key){$notificationData.push($params.notification_type_key);}
        $notification.valid = $notificationData.length == 3;
        $notification.url = $location.replace('/notification/'+$notificationData.join('/'), '');
        var $url = $notification.url.split('/');
        $notification.module = $url[$url.length-1];
        return $notification;
    },
    menu_selector:function(){
        libs.globalUrl();
    }
};
